export default "__VITE_ASSET__B8Hz7txH__"